import React from 'react';
import { Mail, Phone, Instagram } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#0A2846] text-[#E8EEF3] pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          <div>
            <img
              src="https://customer-assets.emergentagent.com/job_premium-reinigung/artifacts/7bybhkxc_8858D91C-BC6F-4317-A826-E2C324679F0A.PNG"
              alt="PROBAV Logo"
              className="h-16 w-auto mb-4"
            />
            <p className="text-[#E8EEF3]/80 leading-relaxed">
              Professionelle Gebäudereinigung für Gewerbe, Büros und Wohnimmobilien.
            </p>
          </div>

          <div>
            <h3 
              className="text-xl font-semibold mb-4"
              style={{
                background: 'linear-gradient(135deg, #D4AF37 0%, #FFD700 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}
            >
              Schnellzugriff
            </h3>
            <ul className="space-y-2">
              <li>
                <a href="#services" className="text-[#E8EEF3]/80 hover:text-[#D4AF37] transition-colors duration-300">
                  Leistungen
                </a>
              </li>
              <li>
                <a href="#about" className="text-[#E8EEF3]/80 hover:text-[#D4AF37] transition-colors duration-300">
                  Über uns
                </a>
              </li>
              <li>
                <a href="#process" className="text-[#E8EEF3]/80 hover:text-[#D4AF37] transition-colors duration-300">
                  Ablauf
                </a>
              </li>
              <li>
                <a href="#why-us" className="text-[#E8EEF3]/80 hover:text-[#D4AF37] transition-colors duration-300">
                  Warum PROBAV
                </a>
              </li>
            </ul>
          </div>

          <div id="contact">
            <h3 
              className="text-xl font-semibold mb-4"
              style={{
                background: 'linear-gradient(135deg, #D4AF37 0%, #FFD700 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}
            >
              Kontakt
            </h3>
            <div className="space-y-3">
              <a
                href="mailto:kontakt@probav-reinigung.de"
                className="flex items-center space-x-3 text-[#E8EEF3]/80 hover:text-[#D4AF37] transition-colors duration-300"
              >
                <Mail className="w-5 h-5" />
                <span>kontakt@probav-reinigung.de</span>
              </a>
              <a
                href="tel:+491701247477"
                className="flex items-center space-x-3 text-[#E8EEF3]/80 hover:text-[#D4AF37] transition-colors duration-300"
              >
                <Phone className="w-5 h-5" />
                <span>+49 170 1247477</span>
              </a>
              <a
                href="https://instagram.com/probav_reinigung"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-3 text-[#E8EEF3]/80 hover:text-[#D4AF37] transition-colors duration-300"
              >
                <Instagram className="w-5 h-5" />
                <span>@probav_reinigung</span>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-[#E8EEF3]/20 pt-8 flex flex-col md:flex-row justify-between items-center text-[#E8EEF3]/60">
          <p>&copy; {new Date().getFullYear()} PROBAV Gebäudereinigung. Alle Rechte vorbehalten.</p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <Link to="/impressum" className="hover:text-[#D4AF37] transition-colors duration-300">
              Impressum & Datenschutz
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;